


<template lang="jade">

	div.player
		video.video-js.vjs-default-skin.vjs-fill.vjs-big-play-centered(
			ref="videoPlayer"
		)

</template>






<script>



	import videojs from 'video.js'
	import 'video.js/dist/video-js.css'
	//import 'videojs-sublime-skin/dist/videojs-sublime-skin.min.css'



	export default {
	    name : 'player',
	    props : {
	        posterSRC : null,
			videoSRC : null
	    },
	    data() {
	        return {
	            player : null
	        }
	    },
	    mounted() {

	        this.player = videojs(
				this.$refs.videoPlayer,
				{
					autoplay : true,
					controls : true,
					responsive : true,
					poster : this.posterSRC,
					sources : [
						{
							src : this.videoSRC,
							type : 'video/mp4'
						}
					]
				}
			)

			this.player.on('ready', function() {
				//console.log('Player onReady')
			})

			this.player.on('play', function() {
				//console.log('Player onPlay')
			})

			this.player.on('pause', function() {
				//console.log('Player onPause')
			})

	    },
	    beforeDestroy() {

	        if (this.player) {
	            this.player.dispose()
	        }

	    }
	}



</script>



<style lang="stylus">

	.vjs-big-play-button
		display none !important

	.vjs-poster
		-webkit-background-size cover !important
		-moz-background-size cover !important
		-o-background-size cover !important
		background-size cover !important

	.vjs-tech
		object-fit cover

</style>


<style lang="stylus">

	.player
		width 100%
		height 100%

</style>



// WEBPACK FOOTER //
// src/components/video/player.vue